import { useContext } from 'react';

import { OrderContext } from 'modules/order/common/providers/OrderProvider/OrderContext';

export const useCreateOrderContext = () => {
  const context = useContext(OrderContext);
  if (!context) {
    throw new Error(
      'useCreateOrderContext must be used within a CreateOrderProvider'
    );
  }
  return context;
};
